/**
 * isLiveTenant — returns true for any tenant that is running in production
 * with real data (i.e. NOT the demo tenant).
 *
 * Pages that use mock data call this and show an empty state for live tenants
 * so demo data never appears to real clients.
 */
export function isLiveTenant(tenantId: string): boolean {
  return tenantId !== "demo";
}

/**
 * isLiveHost — synchronously checks window.location.hostname to determine
 * whether the current page is running on a live (non-demo) host.
 * Safe to call in useState lazy initialisers and useEffect bodies.
 * Returns false on the server (SSR/edge) and on localhost / vercel.app previews.
 */
export function isLiveHost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return !h.includes("localhost") && !h.includes(".vercel.app");
}
